<div class="comment">
  <div class="d-flex flex-column">
    <div class="comment-section">
      <div class="w-100">
        <input
          (keydown.enter)="
            !commentPending && commentControl.valid && addComment()
          "
          [formControl]="commentControl"
          [attr.aria-invalid]="commentControl.invalid || null"
          placeholder="{{ 'ENTER_COMMENT_HERE' | translate }}"
          type="text"
          class="comment-input"
        />
      </div>
    </div>
    @if (commentControl.errors?.["htmlComment"]) {
      <div class="mt-1 text-red">
        {{ "HTML_TAG_ERROR" | translate }}
      </div>
    }
    @if (commentControl.errors?.["invalidCharacters"]) {
      <div class="mt-1 text-red">
        {{ "INVALID_CHARACTERS" | translate }}
      </div>
    }
  </div>

  <div class="comment-container">
    @if (
      commentPending || commentFailed || (fadeOutAnimationDone && newComment)
    ) {
      <div
        #headerContainer
        class="comment-item d-flex flex-row align-items-center gap-10"
        [class.comment-item-failed]="commentFailed && !commentPending"
        [class.comment-item-pending]="commentPending && !commentFailed"
      >
        <div
          [class.w-100]="commentFailed || commentPending"
          [@fadeOut]
          (@fadeOut.start)="onFadeOutStart()"
          (@fadeOut.done)="onFadeOutDone($event)"
        >
          @if (commentPending) {
            <div
              class="comment-item-text w-100 text-center d-block align-content-center text-truncate"
            >
              <span class="loading">
                {{ "LOADING" | translate }}
              </span>
            </div>
          } @else if (commentFailed) {
            <div class="d-flex flex-row align-items-center gap-10">
              <span style="width: 26px"></span>
              <div
                class="comment-item-text w-100 text-center d-block align-content-center text-truncate"
              >
                {{ errorMessage || "COMMENT_FAILED" | translate }}
              </div>
              <span style="width: 26px">
                <svg-icon
                  (click)="hideFailedComment()"
                  class="comment-item-failed-icon"
                  name="close"
                ></svg-icon>
              </span>
            </div>
          }
        </div>

        @if (newComment && fadeOutAnimationDone) {
          <div class="w-100 comment-item-new" [@fadeIn]>
            <div class="comment-item-top">
              <div class="comment-item-name">
                <svg-icon name="account"></svg-icon>
                <span>{{ newComment.userFullName }}</span>
              </div>
              <div class="comment-item-date">
                <span>{{
                  newComment.dateTimeComment | momentPipe: "MMMM D, YYYY"
                }}</span>
                <span>{{
                  commentMoment(newComment.dateTimeComment)
                    | momentPipe: "HH:mm"
                }}</span>
              </div>
            </div>
            <div class="comment-item-text">
              {{ newComment.comment }}
            </div>
          </div>
        }
        @if (newComment) {
          <div #newContentMeasure class="visually-hidden" aria-hidden="true">
            <div class="w-100 comment-item-new">
              <div class="comment-item-top">
                <div class="comment-item-name">
                  <svg-icon name="account"></svg-icon>
                  <span>{{ newComment.userFullName }}</span>
                </div>
                <div class="comment-item-date">
                  <span>{{
                    newComment.dateTimeComment | momentPipe: "MMMM D, YYYY"
                  }}</span>
                  <span>{{
                    commentMoment(newComment.dateTimeComment)
                      | momentPipe: "HH:mm"
                  }}</span>
                </div>
              </div>
              <div class="comment-item-text">
                {{ newComment.comment }}
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (comments?.length) {
      @for (comment of comments; track comment.commentId) {
        @if (newComment?.commentId !== comment.commentId) {
          <div class="comment-item">
            <div class="comment-item-top">
              <div class="comment-item-name">
                <svg-icon name="account"></svg-icon>
                <span>{{ comment.userFullName }}</span>
              </div>
              <div class="comment-item-date">
                <span>{{
                  comment.dateTimeComment | momentPipe: "MMMM D, YYYY"
                }}</span>
                <span>{{
                  commentMoment(comment.dateTimeComment) | momentPipe: "HH:mm"
                }}</span>
              </div>
            </div>
            <div class="comment-item-text">
              {{ comment.comment }}
            </div>
          </div>
        }
      }
    } @else if (!commentPending) {
      <div class="no-comments">
        {{ "NO_PREVIOUS_COMMENTS" | translate }}
      </div>
    }
  </div>
</div>
